import { render, staticRenderFns } from "./PopoverSpecialOfferPromotionDetailComponent.vue?vue&type=template&id=0804565b"
import script from "./PopoverSpecialOfferPromotionDetailComponent.vue?vue&type=script&lang=js"
export * from "./PopoverSpecialOfferPromotionDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./PopoverSpecialOfferPromotionDetailComponent.vue?vue&type=style&index=0&id=0804565b&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports